import { inject } from '@angular/core'
import { CanActivateFn, RedirectCommand, Router } from '@angular/router'

import { AuthService } from '../../../shared/services/auth.service'

export const twoFactorAuthGuard: CanActivateFn = async () => {
	const router = inject(Router)
	const authService = inject(AuthService)

	if (authService.loginResponse !== null) {
		return true
	}

	return new RedirectCommand(router.parseUrl('/home'))
}
